import { format, getTime, formatDistanceToNow } from "date-fns";
import dayjs from "dayjs";
import moment from "moment";

// ----------------------------------------------------------------------

export function fDate(date, newFormat) {
  const fm = newFormat || "dd MMM yyyy";

  return date ? format(new Date(date), fm) : "";
}

export function fDateTime(date, newFormat) {
  const fm = newFormat || "dd MMM yyyy p";

  return date ? format(new Date(date), fm) : "";
}

export function fTimestamp(date) {
  return date ? getTime(new Date(date)) : "";
}

export function fToNow(date) {
  return date
    ? formatDistanceToNow(new Date(date), {
        addSuffix: true,
      })
    : "";
}

export function textToFormateDate(date) {
  if (date) {
    let dateFormated = dayjs(date).format("MM/DD/YYYY");
    return dateFormated;
  }
  return null;
}

export function formateDate(date) {
  if (date) {
    let dateFormated = dayjs(date).format("YYYY-MM-DD");
    return dateFormated;
  }
  return null;
}
export const calculateTotalDateTime = (startDate, endDate, breakDuration) => {
  if (!startDate || !endDate) return 0;
  if (!startDate.isValid() || !endDate.isValid()) return 0;
  // Calculate the total duration in minutes
  const diff = endDate.diff(startDate, "minutes");

  return diff;
};

export const calculateTotalTime = (timeStart, timeEnd, breakDuration) => {
  if (!timeStart || !timeEnd) return 0;

  // Parse the start and end times in 24-hour format
  const start = moment(timeStart, "HH:mm");
  let end = moment(timeEnd, "HH:mm");

  // Handle case where end time is the next day
  if (end.isBefore(start)) {
    end.add(1, "day");
  }

  // Calculate the total duration in minutes
  let durationMinutes = end.diff(start, "minutes");

  // Subtract the break duration if provided
  if (breakDuration) {
    const temp = moment(breakDuration).format("HH:mm");

    const [breakHours, breakMinutes] = temp.split(":").map(Number);
    const breakMinutesTotal = breakHours * 60 + breakMinutes;
    durationMinutes -= breakMinutesTotal;
    durationMinutes = durationMinutes > 0 ? durationMinutes : 0;
  }

  return durationMinutes;
};

export const formatMinutesToHHmm = (totalMinutes) => {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
    2,
    "0"
  )}`;
};
